<script setup>
import { swalError, swalSuccess } from '@/helper';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { check_payment, get_invoice } from '@/services/subscriptions';
import invoiceCard from './invoiceCard.vue'

const route = useRoute()
const isLoading = ref(true)
const isError = ref(false)
const errorMessage = ref('')
const payment_id = ref('')

onMounted(async()=>{
  setTimeout(async ()=>{
    await retrieve_session()
    isLoading.value = false
  }, 3000)
})

const inv_id = ref('')
const session_id = ref('')
const payment_invoice_number = ref('')
async function retrieve_session(){
  session_id.value = localStorage.getItem('session_id')
  payment_id.value = localStorage.getItem('payment_id')
  localStorage.removeItem('session_id')
  localStorage.removeItem('payment_id')
  
  if (!session_id.value){
    isError.value = true
    errorMessage.value = 'No payment session found'
    return
  }
  
  let response = await check_payment(session_id.value)
  
  if (response.error){
    isError.value = true
    errorMessage.value = response.result?.error || 'Failed to verify payment'
    swalError(errorMessage.value, true)
    return
  }
  
  if (!response.result.success){
    isError.value = true
    errorMessage.value = response.result.error || 'Payment verification failed'
    swalError(errorMessage.value, true)
    return
  }
  
  const sessionData = response.result.session
  const paymentData = response.result.payment
  
  if (paymentData && paymentData.invoice_number){
    payment_invoice_number.value = paymentData.invoice_number
  }
  
  if (sessionData.payment_status !== 'paid'){
    isError.value = true
    errorMessage.value = 'Payment not completed'
    swalError(errorMessage.value, true)
    return
  }
  
  inv_id.value = sessionData.invoice
  if (inv_id.value){
    await retrieve_invoice()
  }
  
  swalSuccess('Payment successful! Your subscription will be activated within 7 working days.')
}

const inv_data = ref({})
async function retrieve_invoice(){
  let response = await get_invoice(inv_id.value)
  if (response.error){
    console.error('Failed to retrieve invoice:', response.result)
    return
  }
  
  if (!response.result.success){
    console.error('Invoice retrieval failed:', response.result.error)
    return
  }
  
  inv_data.value = response.result.invoice
}
</script>

<template>
  <div class="pt-5">
    <loadingCard v-if="isLoading" />
    <template v-else>
      <template v-if="isError">
        <div class="container">
          <div class="alert alert-danger" role="alert">
            <h4 class="alert-heading">Payment Error</h4>
            <p>{{ errorMessage }}</p>
            <hr>
            <p class="mb-0">Please contact support if you were charged but subscription was not activated.</p>
          </div>
        </div>
      </template>
      <invoiceCard v-else :inv_data="inv_data" :payment_invoice_number="payment_invoice_number" :payment_id="payment_id" />
    </template>
  </div>
</template>